import React from 'react';

import { video, videoPreview, aiBadge } from './recipe-video-preview.module.scss';
import { title, separator } from './common-recipe-molecules.module.scss';

import Separator from '../../atoms/separator';
import VideoPostPreview from '../video-post-preview';
import AiImageBadge from '../../atoms/ai-image-badge';

const RecipeVideoPreview = ({ recipe, className = '' }) => {
    return (
        <div className={`${video} ${className}`}>
            <h2 className={title}>Video</h2>
            <Separator className={separator} />
            <VideoPostPreview
                className={videoPreview}
                videoUrl={recipe.videoUri}
                provider={recipe.videoProvider}
                imageUrl={recipe.coverUri}
                imageOverlay={recipe.isCoverAiGenerated && <AiImageBadge className={aiBadge} />}
            />
        </div>
    );
};

export default RecipeVideoPreview;
